import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { faqs } from "../../data/content";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section className="bg-mist px-5 py-16 sm:py-20" data-id="element-139" data-mp="729ncqgkskqt">
      <div className="mx-auto max-w-3xl" data-id="element-140" data-mp="731g7tisg4de">
        <SectionHeading kicker="Frequently asked questions" title="Everything You Need to Know Before Getting Started" data-id="element-141" data-mp="236t8124vyxm" />
        <div className="mt-10 space-y-3" data-id="element-142" data-mp="h0z4ui4k836j">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-white" data-id="element-143" data-mp="1seje5zu44otv" data-mpi={i}>
                <h3 data-id="element-144" data-mp="1sd01ej7o0vwu">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-[17px] font-extrabold leading-snug text-navy-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-145" data-mp="1sge1fksuwt14">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-dark transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-146" data-mp="vr5xxwx1dsey" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-147" data-mp="81tem47zw3yx">
                  {isOpen && <motion.div id={`faq-${i}`} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-148" data-mp="cw7d4fhyer7t">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-149" data-mp="xf2edm5msb2a">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCta label="I have my answer — let's start" note="$27 USD one-time · 7-day guarantee" data-id="element-150" data-mp="4rg27pic7y3t" />
      </div>
    </section>;
}